// ChatMessages.js — shared renderer for the conversation stream: user and
// assistant bubbles, action receipts (the ledger), and faint reasoning
// steps. Used by the ChatOverlay; the ChatBar itself stays input-only.
import React from 'react';
import { T } from './liveTheme';

const ChatMessages = ({ messages, actions }) => (
  <>
    {messages.map((m) =>
      m.role === 'step' ? (
        <p
          key={m.id}
          style={{
            margin: '2px 0 6px',
            textAlign: 'center',
            fontSize: 10,
            fontStyle: 'italic',
            color: T.textFaint,
          }}
        >
          · {m.text} ·
        </p>
      ) : m.role === 'receipt' ? (
        <div
          key={m.id}
          title={m.why || undefined}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 6,
            margin: '4px 0 8px',
            fontSize: 11,
            color: m.undone ? T.textFaint : T.greenBright,
          }}
        >
          <i
            className={`fa ${m.undone ? 'fa-rotate-left' : 'fa-check'}`}
            aria-hidden="true"
            style={{ fontSize: 10 }}
          />
          <span
            style={{
              textDecoration: m.undone ? 'line-through' : 'none',
              textAlign: 'center',
            }}
          >
            {m.text}
          </span>
          {m.undoable && !m.undone && (
            <span
              onClick={() => actions.undoReceipt(m.id)}
              style={{
                color: T.textSecondary,
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
            >
              Undo
            </span>
          )}
          {m.action?.type === 'review' && (
            <span
              onClick={() => actions.setReviewMode(true)}
              style={{
                background: T.green,
                color: T.greenDark,
                fontWeight: 600,
                padding: '1px 8px',
                borderRadius: 8,
                cursor: 'pointer',
              }}
            >
              {m.action.label}
            </span>
          )}
        </div>
      ) : (
        <div
          key={m.id}
          style={{
            display: 'flex',
            justifyContent: m.role === 'user' ? 'flex-end' : 'flex-start',
            marginBottom: 6,
          }}
        >
          <span
            style={{
              maxWidth: '85%',
              background:
                m.role === 'user' ? 'rgba(45,206,137,0.18)' : T.surfaceCard,
              color: m.role === 'user' ? '#d1fae5' : T.textSoft,
              fontSize: 12,
              lineHeight: 1.5,
              padding: '6px 10px',
              borderRadius: 10,
              opacity: m.pending ? 0.8 : 1,
              whiteSpace: 'pre-wrap',
            }}
          >
            {m.text}
            {m.pending ? ' …' : ''}
          </span>
        </div>
      ),
    )}
  </>
);

export default ChatMessages;
